var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * CZNA-1644 — the "Druh" facet of the review queue: one checkbox per kind (new proposals,
 * corrections of published records, published records to review), each with its count.
 *
 * <p>The counts come from the server under the queue's own visibility and the chosen
 * siglas, so they say how many rows each choice would leave. Every kind is always offered,
 * also at zero and before the counts arrive, so a chosen kind can always be cleared.
 */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Checkbox, MessageBanner } from '@folio/stripes/components';
import { REVIEW_QUEUE_KINDS, } from '../types/api';
var ReviewQueueKindFilter = function (_a) {
    var facet = _a.facet, isError = _a.isError, selection = _a.selection, onChange = _a.onChange;
    var intl = useIntl();
    var countOf = function (kind) { var _a, _b; return (_b = ((_a = facet === null || facet === void 0 ? void 0 : facet.kinds) !== null && _a !== void 0 ? _a : []).find(function (option) { return option.kind === kind; })) === null || _b === void 0 ? void 0 : _b.itemCount; };
    var toggle = function (kind, checked) { return onChange(checked
        ? __spreadArray(__spreadArray([], selection, true), [kind], false) : selection.filter(function (value) { return value !== kind; })); };
    return (React.createElement("div", { "data-testid": "review-queue-kind-filter" },
        isError ? (React.createElement(MessageBanner, { type: "error" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.review.queue.kind.error" }))) : null,
        REVIEW_QUEUE_KINDS.map(function (kind) {
            var label = intl.formatMessage({ id: "ui-czna-authorities.review.queue.kind.filter.".concat(kind) });
            var count = countOf(kind);
            return (React.createElement(Checkbox, { key: kind, label: count === undefined ? label : intl.formatMessage({ id: 'ui-czna-authorities.review.queue.kind.option' }, { label: label, count: count }), checked: selection.includes(kind), onChange: function (event) {
                    return toggle(kind, event.target.checked);
                }, "data-test-kind-option": kind }));
        }),
        selection.length > 0 ? (React.createElement(Button, { buttonStyle: "link", marginBottom0: true, onClick: function () { return onChange([]); }, "data-test-kind-clear": true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.review.queue.kind.clear" }))) : null));
};
export default ReviewQueueKindFilter;
